import React, { useMemo } from "react";
import WalletService from "../../services/WalletService";
import apiClient from "../../auth/apiClient";
import { useStyles } from "../../pages/OnePass/styles";
import appleWalletBadge from "../../assets/apple-wallet-badge.svg";

const AppleWalletButton = ({ ticketId }) => {
  const classes = useStyles();
  const walletService = useMemo(() => new WalletService(apiClient), []);

  const handleWalletClick = async () => {
    try {
      const response = await walletService.createAppleWalletPass(ticketId);

      const blob = new Blob([response.data], { type: "application/vnd.apple.pkpass" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `onepass-${ticketId}.pkpass`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download Apple Wallet pass:", error);
    }
  };

  return (
    <button
      type="button"
      className={classes.walletBadgeWrapper}
      onClick={handleWalletClick}
      aria-label="Add to Apple Wallet"
    >
      <img
        src={appleWalletBadge}
        alt="Add to Apple Wallet"
        className={classes.walletBadge}
      />
    </button>
  );
};

export default AppleWalletButton;

